(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-product-how-to-use"] && !window.DesignMode) return;
  try {
    

    function removeSection(evt){
        var sectionSelector = document.querySelector(".product_handle_data");
        if (sectionSelector !== null) {
            var productHandle = sectionSelector.dataset.productHandle;
        } else {
            var productHandle = window.location.pathname.replace('/products/', '')
        }
        var shopifyData = window.parent.Shopify.sections[evt.detail.sectionId];
        setTimeout( function (){
            removeSectionLi()
        }, 1000);
        return
        //if (shopifyData) {
            //setTimeout( function (){
                //removeSectionLi()
            //}, 1000);
            //return
            //for (let i in shopifyData.settings) {
                //if (shopifyData.settings[i].id != 'product_handle') {
                    //continue
                //}
                //if (shopifyData.settings[i].value != productHandle) {
                    //var element = window.parent.document.querySelector('li[data-section-id="' + evt.detail.sectionId + '"]')
                    //if (element) {
                        //element.remove();
                        //console.log("Removed");
                    //}
                //}
            //}
        //}
    }

    $(document)
    .on( 'shopify:section:select', removeSection )
    .on( 'shopify:section:load', removeSection )
    .on( 'shopify:section:unload', removeSection )
    .on( 'shopify:section:deselect', removeSection )
    .on( 'shopify:section:reorder', removeSection )
    .on( 'shopify:block:load', removeSection )
    .on( 'shopify:block:unload', removeSection )
    .on( 'shopify:block:select', removeSection )
    .on( 'shopify:block:deselect', removeSection )
    ;

    function removeSectionLi(){
        var sectionSelector = document.querySelector(".product_handle_data");
        if (sectionSelector !== null) {
            var productHandle = sectionSelector.dataset.productHandle;
        } else {
            var productHandle = window.location.pathname.replace('/products/', '')
        }
        var sectionDetails = window.parent.Shopify.sections
        var contentForIndex = window.parent.Shopify.contentForIndex
        for (let j=0; j < contentForIndex.length; j++) {
            for (let i in sectionDetails[contentForIndex[j]].settings) {
                if (sectionDetails[contentForIndex[j]].settings[i].id != 'product_handle') {
                    continue
                }
                console.log(sectionDetails[contentForIndex[j]].settings[i].value,"jijkj")
                if (!sectionDetails[contentForIndex[j]].settings[i].value || sectionDetails[contentForIndex[j]].settings[i].value.handle != productHandle)  {
                    var element = window.parent.document.querySelector('li[data-section-id="' + contentForIndex[j] + '"]')
                    if (element) {
                        element.classList.add('theme-editor__section--disabled');
                        // element.remove()
                        console.log("Removed")
                    }
                }
            }
        }
    }
    setTimeout( function () {
        removeSectionLi()
        setTimeout( function () {
            removeSectionLi()
            setTimeout( function () {
                removeSectionLi()
                setTimeout( function () {
                    removeSectionLi()
                }, 5000)
            }, 4000)
        }, 3000)
    })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
    var loadProductRecommendationsIntoSection = function() {
        var productRecommendationsSection = document.querySelector(".product-recommendations");
        if (productRecommendationsSection === null) { 
            return; 
        }
        var productId = productRecommendationsSection.dataset.productId;
        var requestUrl = "/recommendations/products?section_id=product-recommendations&product_id=" + productId;
        var request = new XMLHttpRequest();
        request.open("GET", requestUrl);
        request.onload = function() {
            if (request.status >= 200 && request.status < 300) {
                var container = document.createElement("div");
                container.innerHTML = request.response;
                productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
            }
        };
        request.send();
    };
    document.addEventListener("shopify:section:load", function(event) {
        if (event.detail.sectionId === "product-recommendations") {
            loadProductRecommendationsIntoSection();
        }
    });
    loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
